import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page chat-page" }
const _hoisted_2 = {
  key: 0,
  class: "chat-error"
}
const _hoisted_3 = { class: "chat-layout panel" }
const _hoisted_4 = { class: "chat-history" }
const _hoisted_5 = {
  key: 0,
  class: "chat-empty-history"
}
const _hoisted_6 = { class: "chat-conversation" }
const _hoisted_7 = {
  key: 0,
  class: "loading"
}
const _hoisted_8 = {
  key: 1,
  class: "chat-welcome"
}
const _hoisted_9 = { class: "chat-title" }
const _hoisted_10 = {
  ref: "messagesElement",
  class: "chat-messages"
}
const _hoisted_11 = {
  key: 0,
  class: "chat-welcome compact"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "chat-system-label"
}
const _hoisted_15 = {
  key: 1,
  class: "stream-cursor",
  "aria-hidden": "true"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "page-heading" }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("small", null, "RubyLLM · OpenRouter"),
        _createElementVNode("h1", null, "AI-чат")
      ], -1 /* CACHED */)),
      _createElementVNode("button", {
        class: "primary",
        onClick: $setup.createChat
      }, "+ Новый чат")
    ]),
    ($setup.error && !$setup.selected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString($setup.error) + " ", 1 /* TEXT */),
          ($setup.error.includes('настро') || $setup.error.includes('модел'))
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: "/settings/ai"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Открыть настройки", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("aside", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("header", null, "История чатов", -1 /* CACHED */)),
        (!$setup.chats.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "История пока пуста"))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chats, (chat) => {
          return (_openBlock(), _createBlock(_component_RouterLink, {
            key: chat.id,
            to: `/chats/${chat.id}`,
            class: _normalizeClass({active:String($setup.route.params.id)===String(chat.id)})
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(chat.title), 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString(chat.preview || chat.model), 1 /* TEXT */),
              _createElementVNode("time", null, _toDisplayString(new Date(chat.updated_at).toLocaleString('ru-RU')), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("main", _hoisted_6, [
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Загрузка…"))
          : (!$setup.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "✦", -1 /* CACHED */)),
                _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Начните новый чат", -1 /* CACHED */)),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "После первого сообщения чат появится в истории.", -1 /* CACHED */)),
                _createElementVNode("button", {
                  class: "primary",
                  onClick: $setup.createChat
                }, "Создать чат")
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("header", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString($setup.selected.title), 1 /* TEXT */),
                    _createElementVNode("small", null, _toDisplayString($setup.selected.model), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (!$setup.selected.messages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("span", null, "✦", -1 /* CACHED */),
                        _createElementVNode("h2", null, "Чем помочь?", -1 /* CACHED */),
                        _createElementVNode("p", null, "Например: «Найди партнёра по имени, email или интеграции»", -1 /* CACHED */)
                      ]))]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selected.messages, (message) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: message.id,
                      class: _normalizeClass(["chat-message", [message.role,{typing:message.thinking,streaming:message.streaming}]])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(message.role === 'user' ? 'Вы' : message.role === 'system' ? '!' : 'AI'), 1 /* TEXT */),
                      (message.thinking && !message.content)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("span", { class: "thinking-loader" }, [
                              _createElementVNode("i"),
                              _createElementVNode("i"),
                              _createElementVNode("i")
                            ], -1 /* CACHED */),
                            _createTextVNode(" Думает…", -1 /* CACHED */)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (message.role === 'system')
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_14, "Системное сообщение"))
                              : _createCommentVNode("v-if", true),
                            _createVNode($setup["ChatMessageContent"], {
                              content: message.content
                            }, null, 8 /* PROPS */, ["content"]),
                            (message.streaming)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                              : _createCommentVNode("v-if", true)
                          ]))
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */),
                _createElementVNode("form", {
                  class: "chat-composer",
                  onSubmit: _withModifiers($setup.sendMessage, ["prevent"])
                }, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.draft) = $event)),
                    rows: "2",
                    placeholder: "Сообщение…",
                    disabled: $setup.sending,
                    onKeydown: $setup.submitOnEnter
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16), [
                    [_vModelText, $setup.draft]
                  ]),
                  _createElementVNode("button", {
                    class: "primary",
                    disabled: $setup.sending || !$setup.draft.trim()
                  }, _toDisplayString($setup.sending ? "Отправка…" : "Отправить"), 9 /* TEXT, PROPS */, _hoisted_17),
                  _cache[9] || (_cache[9] = _createElementVNode("small", null, "Enter — отправить, Shift+Enter — новая строка", -1 /* CACHED */))
                ], 32 /* NEED_HYDRATION */)
              ], 64 /* STABLE_FRAGMENT */))
      ])
    ])
  ]))
}